import Vue from 'vue'
import iView from 'iview'
import Router from 'vue-router'
Vue.use(Router)
import store from '../store'
import {queryMenus} from '@/api/menus'

import dictionary from './dictionary'
import role from './role'
import login from './login'

import register from './register'
import appregister from './appregister'
import forgetpassword from './forgetpassword'

import dashboard from './dashboard'
import user from './user'
import unit from './unit'
import menu from './menu'
import file from './file'
import demo from './demo'
import business from './business'
import stats from './stats'
import workflow from './workflow'
import task from './task'
import log from './log'
import fwsc from './person'
import fwscseller from './seller'
import operatormanager from './operatormanager'
import zcfw from './zcfw'
import finance from './finance'
import college from './college'
import energy from './energy'
import energyview from './energyview'
import release from './release'
import rewardregister from './rewardregister'
import declare from './declare'
import material from './material'
import message from './message'
import demand from './demand'
import carrier from './carrier'
import shop from './shop'
import fwscverify from './fwscverify'
import specialview from './specialview'
import expert from './expert'
import information from './information'
import vendororder from './vendororder'
import fwscad from './fwscad'
import specialedit from './specialedit'
import energyedit from './energyedit'
import groupspecialview from './groupspecialview'
import groupspecialedit from './groupspecialedit'
import industryspecialedit from './industryspecialedit'
import industryspecialview from './industryspecialview'
import validspecialedit from './validspecialedit'
import validspecialview from './validspecialview'
import talentsapplyedit from './talentsapplyedit'
import talentsapplyview from './talentsapplyview'
import xmsbstatistics from './xmsbstatistics'
import xmsb from './xmsb'
import insuranceapplyedit from './insuranceapplyedit'
import insuranceapplyview from './insuranceapplyview'
import intermediaryapplyedit from './intermediaryapplyedit'
import intermediaryapplyview from './intermediaryapplyview'
import foreignapplyedit from './foreignapplyedit'
import foreignapplyview from './foreignapplyview'
import contractapplyedit from './contractapplyedit'
import contractapplyview from './contractapplyview'
import activityapplyedit from './activityapplyedit'
import activityapplyview from './activityapplyview'
import disputeapplyedit from './disputeapplyedit'
import disputeapplyview from './disputeapplyview'
import epibolyapplyedit from './epibolyapplyedit'
import epibolyapplyview from './epibolyapplyview'
import internationalapplyedit from './internationalapplyedit'
import internationalapplyview from './internationalapplyview'
import businesscompanyapplyedit from './businesscompanyapplyedit'
import businesscompanyapplyview from './businesscompanyapplyview'
import businessserviceapplyedit from './businessserviceapplyedit'
import businessserviceapplyview from './businessserviceapplyview'
import businessthirdapplyedit from './businessthirdapplyedit'
import businessthirdapplyview from './businessthirdapplyview'
import devspecfundsbrandbuildedit from './devspecfundsbrandbuildedit'
import devspecfundsbrandbuildview from './devspecfundsbrandbuildview'
import devspecfundsentcultivationedit from './devspecfundsentcultivationedit'
import devspecfundsentcultivationview from './devspecfundsentcultivationview'
import devspecfundsentrepinnovationedit from './devspecfundsentrepinnovationedit'
import devspecfundsentrepinnovationview from './devspecfundsentrepinnovationview'
import devspecfundssentinbaseconstedit from './devspecfundssentinbaseconstedit'
import devspecfundssentinbaseconstview from './devspecfundssentinbaseconstview'
import devspecfundssmentserviceplatformedit from './devspecfundssmentserviceplatformedit'
import devspecfundssmentserviceplatformview from './devspecfundssmentserviceplatformview'
import devspecfundsindentcapacitbuildedit from './devspecfundsindentcapacitbuildedit'
import devspecfundsindentcapacitbuildview from './devspecfundsindentcapacitbuildview'
import config from './config'

import jrtj from './jrtj'
import listmgt from './listmgt'
import { checkLogin, goLogin } from '@/api/login'

import expose from './expose'
import userinfo from './userinfo'
import helpcenter from './helpcenter'
import label from './label'
import component from './component'
import pageTransact from './pageTransact'
import growthspecialview from './growthspecialview'
import growthspecialedit from './growthspecialedit'
import corporationfund from './corporationfund'
import corporationfundview from './corporationfundview'
import acceptance from './acceptance'

import bigdata from './bigdata'
import cchistory from './cchistory'

import city from './city'
import cultivation from './cultivation'
import flowable from './flowable';
import ccjt from './ccjt';
const routers = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/blankboard',
      meta: {
        title: '首页',

      },
    },

    ...dashboard,

    ...login,

    ...register,

    ...appregister,

    ...forgetpassword,

    ...dictionary,

    ...log,

    ...user,

    ...unit,

    ...role,

    ...menu,

    ...file,

    ...demo,

    ...business,

    ...stats,

    ...workflow,

    ...operatormanager,

    ...task,

    ...fwsc,

    ...fwscseller,

    ...fwscverify,

    ...zcfw,

    ...finance,

    ...college,

    ...energy,

    ...release,

    ...energyview,

    ...declare,

    ...material,

    ...message,

    ...demand,

    ...carrier,

    ...shop,

    ...expose,

    ...userinfo,

    ...helpcenter,

    ...label,

    ...specialview,

    ...component,

    ...expert,

    ...information,

    ...vendororder,

    ...fwscad,

    ...specialedit,

    ...energyedit,

    ...groupspecialview,

    ...groupspecialedit,

    ...industryspecialedit,

    ...industryspecialview,

    ...pageTransact,

    ...growthspecialview,

    ...growthspecialedit,

    ...validspecialedit,

    ...validspecialview,

    ...corporationfund,

    ...corporationfundview,

    ...jrtj,

    ...listmgt,

    ...acceptance,

    ...talentsapplyview,

    ...talentsapplyedit,

    ...xmsbstatistics,

    ...xmsb,

    ...foreignapplyview,

    ...foreignapplyedit,

    ...contractapplyedit,

    ...contractapplyview,

    ...activityapplyedit,

    ...activityapplyview,

    ...disputeapplyedit,

    ...disputeapplyview,

    ...insuranceapplyedit,

    ...insuranceapplyview,

    ...intermediaryapplyedit,

    ...intermediaryapplyview,

    ...epibolyapplyedit,

    ...epibolyapplyview,

    ...internationalapplyedit,

    ...internationalapplyview,

    ...businesscompanyapplyedit,

    ...businesscompanyapplyview,

    ...businessserviceapplyedit,

    ...businessserviceapplyview,

    ...businessthirdapplyedit,

    ...businessthirdapplyview,

    ...devspecfundsbrandbuildedit,

    ...devspecfundsbrandbuildview,

    ...devspecfundsentcultivationedit,

    ...devspecfundsentcultivationview,

    ...devspecfundsentrepinnovationedit,

    ...devspecfundsentrepinnovationview,

    ...devspecfundssentinbaseconstedit,

    ...devspecfundssentinbaseconstview,

    ...devspecfundssmentserviceplatformedit,

    ...devspecfundssmentserviceplatformview,

    ...devspecfundsindentcapacitbuildedit,

    ...devspecfundsindentcapacitbuildview,

    ...rewardregister,

    ...bigdata,

    ...cchistory,

    ...city,
    ...config,
    ...cultivation,
    ...flowable,
    ...ccjt,
  ]
})

let confirm = false
routers.beforeEach((to, from, next) => {
  iView.LoadingBar.start()

  const { needLogin, isBlack } = to.meta

  if (needLogin === false) {
    return next()
  }
  // 校验是否登录
  checkLogin().then(result => {
    if (result) {
      if (!isBlack) {
        return next()
      }
      // 校验当前登录人是否有该路径的权限

      if (!(store.state.menuPathList && store.state.menuPathList.length > 0)) {
        getMenus().then(resp => {
          const temp = resp.find(p => p === to.path)
          if (!temp) {
            alert('您没有访问权限,请联系管理员！')
            iView.LoadingBar.finish()
          } else {
            return next()
          }
        })
      } else {
        const temp = store.state.menuPathList.find(p => p === to.path)
        if (!temp) {
          alert('您没有访问权限,请联系管理员！')
          iView.LoadingBar.finish()
        } else {
          return next()
        }
      }
    } else {
      goLogin(confirm)
      confirm = true
      iView.LoadingBar.finish()
    }
  })
})

async function getMenus() {
  const carte = await queryMenus()
  let str = dealMenuPathList(carte)
  if (str === '') {
    store.commit('setMenuPathList', [])
    return new Promise(resolve => {
      resolve([])
    })
  } else {
    store.commit('setMenuPathList', str.split(';'))
    return new Promise(resolve => {
      resolve(str.split(';'))
    })
  }
}
function dealMenuPathList(menuList) {
  let str = ''
  menuList.forEach(p => {
    str = str + p.url + ';'
    if (p.children && p.children.length > 0) {
      str = str + dealMenuPathList(p.children)
    }
  })
  return str
}

routers.afterEach(route => {
  iView.LoadingBar.finish()
  store.commit('routeLoaded')
})

export default routers
